import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { _ } from '@ngx-translate/core';
import { DepartmentService } from '../../services/jrni/department.service';
import { DatastoreService } from '../../services';
import { ServicesService } from '../../services/jrni/services.service';
import { BasketService } from '../../services/jrni/basket.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { B2cService } from '../../services/b2c.service';
import { QuestionsService } from '../../services/questions.service';
import { ApiService } from '../../services/jrni/api.service';
import { Buffer } from 'buffer';
import { BBService } from 'bookingbug-core-js';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AppConfig } from "../../app.config";
import { Question } from '../../fees-and-make-it-yours-enhancements/fees-and-make-it-yours-enhancements.component';
import { inject } from "@angular/core";
import moment from 'moment';
import * as he from 'he';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent implements OnInit {


  formBuilder: UntypedFormBuilder = inject(UntypedFormBuilder);
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private deptService: DepartmentService,
    private services: ServicesService,
    private dataStore: DatastoreService,
    private basketService: BasketService,
    private availabilityService: AvailabilityService,
    private questionsService: QuestionsService,
    private b2c: B2cService,
    private apiService: ApiService,
    private configService: ConfigService
  ) { }

  initQuestions: UntypedFormGroup = new UntypedFormGroup({
    ceremony_two_years: new UntypedFormControl('', Validators.required),
    type_of_ceremony: new UntypedFormControl('', Validators.required),
  });

  companyQuestionsForm: UntypedFormGroup = this.formBuilder.group({});
  bookingQuestionsForm: UntypedFormGroup = this.formBuilder.group({});
  companyQuestions = [];
  costBreakDown = [];
  enhancedCostBreakdownQuestions: Question[] = [];
  config: any;
  showContent = false;
  startPageSubtitle = '';
  startPageSubtitleBody = '';

  async ngOnInit() {
    // Clear journey state on start page to ensure fresh start
    sessionStorage.removeItem('journey');

    const appConfig: any = await this.apiService.getConfig(AppConfig.settings.core.company_id);
    this.config = appConfig;

    const pageContent = appConfig?.journey_config?.ceremonies?.page_content?.default;
    this.startPageSubtitle = pageContent?.start_page_subtitle || '';
    this.startPageSubtitleBody = pageContent?.start_page_subtitle_body || '';

    this.dataStore.config = appConfig;
    this.spinner.show();
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length < 1) {
        this.showContent = true;
        this.spinner.hide();
      }
      else {
        setTimeout(() => {
          this.spinner.show();
        }, 0);
      }
      for (const param of Object.keys(params)) {
        console.log('landing', param, params[param]);
        if (param === 'id_token') {
          // post sign in flow
          this.b2c.token = params[param];
          this.b2c.decodeToken();
          const stateBuffer = Buffer.from(params['state'], 'base64').toString('utf-8');
          const stateParams = new URLSearchParams(stateBuffer);
          stateParams.forEach((v, k) => console.log(k, stateParams.get(k)));
          if (stateParams.has('company_id')) {
            // 
            this.deptService.getParentDepartment().then(async (parent) => {
              console.log('depty', parent);
              this.dataStore.selectedDepartment = parent;
              await this.deptService.set(parent);
              this.b2c.company = parent;
              const children = await this.deptService.getChildDepartments(parent);
              for (const child of children) {
                if (child.id == stateParams.get('company_id')) {
                  console.log(`Found location ${child.id} (${child.name})`);
                  await this.deptService.setLocation(child);
                  this.dataStore.selectedLocation = child;
                  break;
                }
              }
              if (stateParams.has('payment_type')) {
                console.log('Setting payemnt type:', stateParams.get('payment_type'));
                this.dataStore.makeItYoursPaymentType = stateParams.get('payment_type');
              }
              if (stateParams.has('service_id')) {
                const services = await this.services.getServices(this.dataStore.selectedLocation);
                for (const service of services) {
                  console.log('service', service.global_id, stateParams.get('service_id'));
                  if (service.global_id == stateParams.get('service_id')) {
                    this.dataStore.selectedService = service;
                    await this.services.set(service);
                    this.b2c.service = service;
                    console.log(`Service set ${service.id} (${service.global_id})`, service);
                    break;
                  }
                }
                console.log('suggestion check', stateParams.get('suggestion'));
                if (stateParams.has('suggestion')) {
                  this.dataStore.selectedSuggestion = JSON.parse(stateParams.get('suggestion'));
                  console.log('Set suggestion', this.dataStore.selectedSuggestion);
                }

                console.log('auth', stateParams.get('auth_token'));
                if (stateParams.has('auth_token')) {
                  localStorage.setItem('auth_token', stateParams.get('auth_token'));
                }
                if (stateParams.has('basket_id')) {
                  // // console.log(await this.dataStore.selectedLocation.$get('total', stateParams.has('basket_id')));
                  // const basket = await this.basketService.getCurrentBasket(this.dataStore.selectedLocation);
                  // console.log(basket);
                  const multiBaskets = await BBService.multiBasket.fetchBasketsByCompanyId(this.dataStore.selectedLocation.id);
                  console.log('multiBaskets', multiBaskets);
                  if (multiBaskets.length > 0) {
                    this.basketService.currentBasket = multiBaskets[0];
                    // console.log(this.basketService.currentBasket);
                    this.basketService.currentServiceItem = multiBaskets[0].items[0];
                    this.dataStore.selectedService.calculated_duration = this.basketService.currentServiceItem.duration;
                    this.b2c.service = this.dataStore.selectedService;
                    console.log(this.basketService.currentServiceItem.service);

										console.log('this.basketService.currentServiceItem', this.basketService.currentServiceItem);
										// setSelectedResource() holds the resource ID everywhere else in the journey
										// (mat-calendar sets it from the facility dropdown / auto-selection), so restore
										// an id here rather than the object the recovered basket item carries — the
										// downstream basket calls read it back as resource_id.
										const restoredResource = this.basketService.currentServiceItem.resource;
										const restoredResourceId =
											this.basketService.currentServiceItem.resource_id ??
											(restoredResource && typeof restoredResource === 'object'
												? restoredResource.id
												: restoredResource);
										this.dataStore.selectedResource = restoredResource;
										this.availabilityService.setSelectedResourceObj(restoredResource);
										this.availabilityService.setSelectedResource(restoredResourceId);

										const times: any = await this.availabilityService.getSlots(
											this.dataStore.selectedLocation,
											{
												company_id: this.dataStore.selectedLocation.id,
												service_id: this.dataStore.selectedService.id,
												start_date: this.basketService.currentServiceItem.start,
												end_date: this.basketService.currentServiceItem.start,
											}
										);
										for (const slot of times.times) {
											if (
												slot.start ==
												this.basketService.currentServiceItem.start
											) {
												console.log(
													`Found slot ${this.basketService.currentServiceItem.start}`
												);
												this.dataStore.selectedSlot = slot;
												await this.availabilityService.setSelectedSlot(slot);
												await this.availabilityService.setEndSlot(slot);
												break;
											}
										}

										// set questions
										this.dataStore.type_of_ceremony =
											this.dataStore.selectedService.detail_group_id;
										const res: any =
											await this.basketService.currentServiceItem.service.$get(
												'questions'
											);
										this.dataStore.answeredQuestions = res.questions;
										this.dataStore.startQuestions = this.companyQuestionsForm;
										this.dataStore.companyQuestionsForm =
											this.companyQuestionsForm;
										this.addQuestionsToForm(res.questions);
										console.log('form', this.companyQuestionsForm.controls);
										this.dataStore.companyQuestions = this.companyQuestions;

										// get the answers back into the datastore from the current service item.
										if (
											this.basketService.currentServiceItem.questions &&
											this.basketService.currentServiceItem.questions.length > 0
										) {
											// this.companyQuestionsForm
											for (const q of this.basketService.currentServiceItem
												.questions) {
												try {
													const found =
														this.companyQuestionsForm.controls[q.id];
													if (found) {
														if (q.answer) {
															found.setValue(q.answer);
														}
													}
												} catch (err) {
													//
												}
											}
										}
										if (stateParams.has('fees')) {
											try {
												const fees = JSON.parse(stateParams.get('fees'));
												console.log('fees', fees);
												this.dataStore.serviceFees = fees;

												await this.onQuestionChange();
												this.b2c.calculateFees();
											} catch (err) {
												console.error(err);
											}
										} else {
											console.log('no fees');
										}
										this.dataStore.companyAnswers = this.companyQuestionsForm;
										this.dataStore.bookingForm = this.bookingQuestionsForm;
										this.router.navigate(['summary']);
									} else {
										console.warn('No baskets found.');
										this.showContent = true;
										this.spinner.hide();
									}
								} else {
									console.warn('No basket ID found in payload.');
									this.spinner.hide();
									this.showContent = true;
								}
              }
              else {
                console.warn('No service ID found in payload.');
                this.spinner.hide();
                this.showContent = true;
              }
            }).catch(err => {
              console.error(err);
              this.spinner.hide();
              this.showContent = true;
            });
          }
          else {
            console.warn('No company ID found in payload.');
            console.log('found journey_type', stateParams.get('journey_type') );
            if (stateParams.has('journey_type')) {
              if (stateParams.get('journey_type') === 'myceremony') {
                // now we redirect
                console.log(`Navigating to MyCeremony login.`);
                console.log('token');
                console.log(this.b2c.token);
                window.location.assign(`https://booking.adaytoremember.london/myceremony?id_token=${this.b2c.token}`);
              }
            }
            this.spinner.hide();
            this.showContent = true;
          }
        }

      }
    });

    this.route.params.subscribe((params) => {
      const service = params['service'];
      this.dataStore.deepLinkedService = service === 'default' ? undefined : service;
      this.dataStore.deepLinkedResource = params['resource'];
      console.log('Deep Linked Resource:', this.dataStore.deepLinkedResource);
      console.log('Deep Linked Service:', this.dataStore.deepLinkedService);
    });

    if (
      !this.dataStore.deepLinkedService &&
      !this.dataStore.deepLinkedResource
    ) {
      this.spinner.hide();
    } else {
      this.spinner.show();
      // set the config
      const _config: any = await this.apiService.getConfig(
        AppConfig.settings.core.company_id
      );
      this.dataStore.config = _config;
      const appConfig: any = await this.configService.getConfig();
      appConfig.first_page_questions_to_ignore =
        _config.journey_config.ceremonies.first_page_questions_to_ignore;
      this.configService.setConfig(appConfig);

      this.deptService.getParentDepartment().then(async (res) => {
        // set department
        this.deptService.set(res);
        const selectedDepartment = await this.deptService.get();

        console.log('Selected Department:', selectedDepartment);

        // if there is a deep linked resource, set it
        if (this.dataStore.deepLinkedService) {
          await this.services
            .getServices(selectedDepartment)
            .then((services) => {
              const matchedService = services.find(
                (service) => service.api_ref == this.dataStore.deepLinkedService
              );

              if (!matchedService) {
                console.error(
                  'Service not found:',
                  this.dataStore.deepLinkedService
                );
                return;
              }

              this.dataStore.selectedService = matchedService;
              this.dataStore.setService = matchedService;
              this.services.set(matchedService);

              if (!this.dataStore.startQuestions) {
                if (matchedService.api_ref.includes('approvedvenue')) {
                  this.dataStore.startQuestions = this.formBuilder.group({
                    '22': new UntypedFormControl(
                      'Approved Premises',
                      Validators.required
                    ),
                  });
                } else {
                  this.dataStore.startQuestions = this.formBuilder.group({
                    '22': new UntypedFormControl(
                      'Old Marylebone Town Hall',
                      Validators.required
                    ),
                  });
                }
              }

              if (!this.dataStore.deepLinkedResource) {
                this.router.navigate(['/calendar']);
              }
            });
        }

        // if there is a deep linked resource, set it
        if (this.dataStore.deepLinkedResource) {
          // Get the children departments (locations) from the selected department
          let location = undefined;
          await this.deptService
            .getSelectedDepartmentChildren(
              selectedDepartment.id,
              this.services.selectedService.id
            )
            .then(async (locations) => {
              location = locations[0];
              this.deptService.setLocation(locations[0]);
            });

          await location.$getResources().then(async (res) => {
            console.log('Resources:', res);

            const matchedResource = res.find(
              (resource) =>
                resource.reference == this.dataStore.deepLinkedResource
            );

            if (!matchedResource) {
              console.error(
                'Resource not found:',
                this.dataStore.deepLinkedResource
              );
              return;
            }

            console.log('Matched Resource:', matchedResource);
            this.availabilityService.setSelectedResourceObj(matchedResource);

            this.dataStore.selectedSuggestion = {
              company_id: location.id,
              description: matchedResource.description,
              image: matchedResource.extra.image,
              pretty_name: matchedResource.name,
              resource_id: matchedResource.id,
            };


            this.router.navigate(['/calendar']);
          });
        }
      });
    }
  }

  startBooking() {
    this.router.navigate(['/departments'],{ skipLocationChange: true });
  }

  startCitizenshipBooking() {
    this.router.navigate(['/start/citizenship'],{ skipLocationChange: true });
  }

  goToUrl(url : string) {
    window.location.href = url;
  }

  addQuestionsToForm(questions) {
    this.companyQuestionsForm = this.formBuilder.group({});
    for (let index = 0; index < questions.length; index++) {
      const question = questions[index];
      question.visible = false;
      question.reference = question.id;
      if (!question.admin_only) {
        if (!question.settings.hasOwnProperty('conditional_question')) {
          question.visible = false; // default hidden all
        }

        const questionControl = question.id;

        if (!question['help_text']) {
          // question without any config
          question.conditionals = {
            page: this.router.url, // show on current page
          };
        } else {
          question.conditionals = JSON.parse(question['help_text']);
        }
        this.companyQuestions.push(question);

        const validators = [];

        // required validators
        if (question.required) {
          validators.push(Validators.required);
        }
        if (question.conditionals['address_lookup']) {
          this.companyQuestionsForm.addControl(
            'postcode_' + questionControl,
            new UntypedFormControl('', validators)
          );
        }
        if (
          question.detail_type == 'check' ||
          question.detail_type == 'check-price'
        ) {
          this.companyQuestionsForm.addControl(
            questionControl,
            new UntypedFormControl(false, validators)
          );
        } else {
          this.companyQuestionsForm.addControl(
            questionControl,
            new UntypedFormControl('', validators)
          );
        }
      }
    }
    // this.onQuestionChange();
  }

  // validate future dates
  futureDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate > currentDate) {
        return { futureDate: true };
      }
      return null;
    } else {
      return null;
    }
  }

  // validate past dates
  pastDateValidator(control) {
    const currentDate = new Date();
    const inputDate = new Date(control.value);
    if (control.value) {
      if (inputDate < currentDate) {
        return { pastDate: true };
      }
      return null;
    } else {
      return null;
    }
  }

  evaluateORCondition(condition, answer) {
    const parts = condition.split(' OR ');

    const evaluation = [];
    // Evaluate each part of the condition
    for (const part of parts) {
      if (part == answer) {
        evaluation.push(true);
      } else {
        evaluation.push(false);
      }
    }

    console.log(evaluation);
    const evalArray = evaluation.some((element) => element === true);
    // If evaluation has a true, one of the values is correct so it will return true
    return evalArray;
  }

  // Function to evaluate custom condition
  evaluateCondition(condition, answer) {
    // Split the condition into individual parts
    const parts = condition.split(' and ');

    // Evaluate each part of the condition
    for (const part of parts) {
      // Split the part into operator and threshold
      let [operator, thresholdStr] = part.split(' ');
      const threshold = parseFloat(thresholdStr);

      // decode html entity
      operator = he.decode(operator);

      if (this.isValidDate(answer)) {
        answer = moment(answer).diff(moment(), 'days') + 1;
      }

      // Perform the comparison based on the operator
      switch (operator) {
        case '<':
          if (!(parseFloat(answer) < threshold)) {
            return false; // If any part is false, the entire condition is false
          }
          break;
        case '<=':
          if (!(parseFloat(answer) <= threshold)) {
            return false;
          }
          break;
        case '>':
          if (!(parseFloat(answer) > threshold)) {
            return false;
          }
          break;
        case '>=':
          if (!(parseFloat(answer) >= threshold)) {
            return false;
          }
          break;
        case '=':
          if (!(parseFloat(answer) === threshold)) {
            return false;
          }
          break;
        default:
          return false;
      }
    }

    // If all parts pass, return true
    return true;
  }

  async validateQuestions(event, question) {
    // Extract the day, month, and year values from the inputs
    const dayInput = (
      document.getElementById(`${question.id}_d`) as HTMLInputElement
    )?.value;
    const monthInput = (
      document.getElementById(`${question.id}_m`) as HTMLInputElement
    )?.value;
    const yearInput = (
      document.getElementById(`${question.id}_y`) as HTMLInputElement
    )?.value;

    // Combine them into a single date string
    const day = dayInput?.padStart(2, '0'); // Ensure day is two digits
    const month = monthInput?.padStart(2, '0'); // Ensure month is two digits
    const year = yearInput; // Year doesn't need padding

    // Validate that the inputs are valid and combine into a date
    if (day && month && year) {
      this.companyQuestionsForm.controls[question.reference].markAsTouched();
      this.companyQuestionsForm.controls[question.reference].markAsDirty();
      const combinedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD
      if (this.isValidDateQuestion(combinedDate)) {
        console.log(combinedDate);
        this.companyQuestionsForm.controls[question.reference].setValue(
          combinedDate
        );
        console.log(this.companyQuestionsForm);
      } else {
        console.error('Invalid date entered:', combinedDate);
        // question.selectedDate = null; // Clear selectedDate if invalid
      }
    } else {
      question.selectedDate = null; // Clear selectedDate if not all fields are filled
    }

    // this.calculateVisibility();
    await this.onQuestionChange();
  }

  isValidDate(dateString: string): boolean {
    // Attempt to create a Date object from the dateString
    const date: Date = new Date(dateString);
    // Check if the created Date object is valid and its string representation matches the input
    return (
      date instanceof Date &&
      !isNaN(date.getTime()) &&
      date.toISOString().slice(0, 10) === dateString
    );
  }

  getAge(dateString): Number {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  isValidDateQuestion(dateString: string): boolean {
    const date = new Date(dateString);
    return !isNaN(date.getTime()); // Check if the date is valid
  }

  async updateRadio(form, question, answer) {
    console.log(form, question, answer);
    form.controls[question].setValue(answer);
    if (question !== 'copyData') {
      await this.onQuestionChange();
    } else {
      // this.radioCopyChange();
    }
  }


  addHyperlinks(question) {
    const linkPattern = /#(.*?)#/g;
    if (linkPattern.test(question.conditionals.component_text)) {
      // replace the #link# with a hyperlink
      question.conditionals.component_text =
        question.conditionals.component_text.replace(
          linkPattern,
          function (match, p1) {
            return (
              `<a href="${question.conditionals.hyperlink}" target="_blank">` +
              p1 +
              '</a>'
            );
          }
        );
    }
    return question.conditionals.component_text;
  }

  setAddress(event, question) {
    // set the address value on the form
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value; // This now gives you `option.id`
    console.log('Selected Value:', selectedValue);
    this.companyQuestionsForm.controls[question.reference].setValue(
      selectedValue
    );
    console.log(this.companyQuestionsForm);
  }

  async onQuestionChange() {
    // this.showServices = false;
    this.dataStore.extraDuration = 0; // reset or we add more on everytime
    if (!this.companyQuestions) {
      return;
    }
    const bookingQuestions = this.companyQuestions;
    // Conditional questions logic
    // for (let index = 0; index < bookingQuestions.length; index++) {
    for (const bookingQuestion of bookingQuestions) {
      bookingQuestion.visible = false; // reset any questions that shouldnt be visible
      // go get the answer for every question from the form
      const control = this.companyQuestionsForm.get(`${bookingQuestion.id}`);
      bookingQuestion.answer = undefined;
      if (control) {
        // set booking question from form values
        bookingQuestion.answer = control.value ? control.value : undefined;
      }

      if (bookingQuestion['help_text']) {
        bookingQuestion.conditionals = JSON.parse(bookingQuestion['help_text']); // to change to settings block soon

        if (bookingQuestion.conditionals.hasOwnProperty('help_text')) {
          bookingQuestion.helptext = bookingQuestion.conditionals.help_text;
          const linkPattern = /#(.*?)#/g;
          if (linkPattern.test(bookingQuestion.helptext)) {
            bookingQuestion.helptext = bookingQuestion.helptext.replace(
              linkPattern,
              function (match, p1) {
                return (
                  `<a href="${bookingQuestion.conditionals.hyperlink}" target="_blank">` +
                  p1 +
                  '</a>'
                );
              }
            );
          }
        }
        if (
          bookingQuestion.conditionals.hasOwnProperty('question-font-colour')
        ) {
          bookingQuestion.customLabelColour =
            bookingQuestion.conditionals['question-font-colour'];
        }
        if (bookingQuestion.conditionals.hasOwnProperty('address_lookup')) {
          if (bookingQuestion.conditionals['address_lookup'] === 'yes') {
            bookingQuestion.address_lookup = true;
          }
        }

        if (
          bookingQuestion.conditionals.hasOwnProperty(
            'address_lookup_multi_line'
          )
        ) {
          bookingQuestion.address_lookup_multi_line = true;
          bookingQuestion.address_lookup_multi_line_to =
            bookingQuestion.conditionals.address_lookup_multi_line.to;
        }
        if (bookingQuestion.conditionals.hasOwnProperty('validation')) {
          if (!this.config.validation) {
            // if there is no validation on the root
            // its probably under the journey_config
            this.config.validation =
              this.config.journey_config?.appointments?.validation;
          }
          if (this.config.validation[bookingQuestion.conditionals.validation]) {
            bookingQuestion.validation =
              this.config.validation[bookingQuestion.conditionals.validation];
            bookingQuestion.validation_message =
              bookingQuestion.conditionals.validation_message;
            const validators = [Validators.pattern(bookingQuestion.validation)];
            if (bookingQuestion.required) {
              validators.push(Validators.required);
            }
            control.setValidators(validators);
            this.companyQuestionsForm.updateValueAndValidity();
          } else {
            if (bookingQuestion.conditionals.validation == 'email') {
              bookingQuestion.validation = 'email';
              bookingQuestion.validation_message =
                bookingQuestion.conditionals.validation_message;
              const validators = [Validators.email];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              control.setValidators(validators);
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        } else {
          if (bookingQuestion.required) {
            control.setValidators(Validators.required);
          }
        }
        if (bookingQuestion.conditionals.hasOwnProperty('section_title')) {
          if (bookingQuestion.conditionals.section_title) {
            bookingQuestion.detail_type = 'heading_2';
          }
        }

        if (bookingQuestion.detail_type === 'date') {
          bookingQuestion.hide_dates_in_future = false;
          bookingQuestion.hide_dates_in_past = false;

          if (
            bookingQuestion.conditionals.hasOwnProperty(
              'hide_dates_in_future'
            ) &&
            bookingQuestion.conditionals.hide_dates_in_future
          ) {
            bookingQuestion.hide_dates_in_future =
              moment().format('YYYY-MM-DD');
            // future date
            if (bookingQuestion.hide_dates_in_future) {
              const validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.futureDateValidator);
              control.setValidators(validators);
              console.log(validators);
              control.updateValueAndValidity();
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }

          if (
            bookingQuestion.conditionals.hasOwnProperty('hide_dates_in_past') &&
            bookingQuestion.conditionals.hide_dates_in_past
          ) {
            bookingQuestion.hide_dates_in_past = moment().format('YYYY-MM-DD');

            // past date
            if (bookingQuestion.hide_dates_in_past) {
              let validators = [];
              if (bookingQuestion.required) {
                validators.push(Validators.required);
              }
              validators.push(this.pastDateValidator);
              control.setValidators(validators);
              control.updateValueAndValidity();
              this.companyQuestionsForm.updateValueAndValidity();
            }
          }
        }

        let conditionals = bookingQuestion.conditionals;
        let show = conditionals.show;
        let hide = conditionals.hide;
        let admin_show = conditionals.admin_show;
        let admin_only = conditionals.admin_only;
        let custom = conditionals.custom;

        // if the booking is only for the admin journey
        if (admin_only && this.dataStore.adminJourney) {
          show = admin_show;
          admin_only = false;
        }

        if (
          Object.keys(show).length === 0 &&
          Object.keys(hide).length === 0 &&
          !conditionals.admin_only
        ) {
          // no hide or show conditional values, just show the question by default
          bookingQuestion.visible = true;
        }

        // show condition loop
        for (const answerId in show) {
          if (answerId == 'hide') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId == 'custom') {
            // custom conditionals to go here
            const conditionalQuestion = this.companyQuestionsForm.get(
              `${Object.keys(show[answerId])[0]}`
            );
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if (
                conditionalQuestion.value ||
                conditionalQuestion.value.length > 0
              ) {
                const condition: any = Object.values(show[answerId])[0];
                if (condition.includes('OR')) {
                  if (
                    this.evaluateORCondition(
                      condition,
                      conditionalQuestion.value
                    )
                  ) {
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (
                    this.evaluateCondition(condition, conditionalQuestion.value)
                  ) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          } else {
            // if this is an admin journey, and there is an admin show value
            if (this.dataStore.adminJourney && admin_show) {
              // if we find a show in both
              if (admin_show[`${answerId}`] && show[`${answerId}`]) {
                // set the show to the admin version as it supersedes show
                show[`${answerId}`] = admin_show[`${answerId}`];
                bookingQuestion.admin_override = true;
              }
            }

            let conditionalQuestion = this.companyQuestionsForm.get(
              `${answerId}`
            );
            if (!conditionalQuestion && show) {
              // console.log(`conditional question is null but has a show value`);
              conditionalQuestion = this.dataStore.startQuestions.get(
                `${answerId}`
              );
            }

            if (conditionalQuestion && conditionalQuestion.value != null) {
              if (
                conditionalQuestion.value ||
                conditionalQuestion.value.length > 0
              ) {
                if (show[answerId].trim() == '*') {
                  // wild card
                  if (
                    conditionalQuestion.value ||
                    conditionalQuestion.value.length > 0
                  ) {
                    // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          }
        }

        // perform hide after show because we want it to take priority
        for (const answerId in hide) {
          if (answerId == 'show') {
            return; // this shouldnt happen only if the setup is wrong
          }
          if (answerId == 'custom') {
            let conditionalQuestion = this.companyQuestionsForm.get(
              `${Object.keys(hide[answerId])[0]}`
            );
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if (
                conditionalQuestion.value ||
                conditionalQuestion.value.length > 0
              ) {
                let condition: any = Object.values(hide[answerId])[0];
                if (condition.includes('OR')) {
                  if (
                    this.evaluateORCondition(
                      condition,
                      conditionalQuestion.value
                    )
                  ) {
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (
                    this.evaluateCondition(condition, conditionalQuestion.value)
                  ) {
                    bookingQuestion.visible = true;
                  }
                }
              }
            }
          } else {
            console.log(`${answerId}`);
            let conditionalQuestion = this.companyQuestionsForm.get(
              `${answerId}`
            );
            if (conditionalQuestion && conditionalQuestion.value != null) {
              if (
                conditionalQuestion.value ||
                conditionalQuestion.value.length > 0
              ) {
                if (show[answerId] == '*') {
                  // wild card
                  if (
                    conditionalQuestion.value ||
                    conditionalQuestion.value.length > 0
                  ) {
                    // if there is any answer
                    bookingQuestion.visible = true;
                  }
                } else {
                  if (`${conditionalQuestion.value}` == `${show[answerId]}`) {
                    bookingQuestion.visible = false;
                  }
                }
              }
            }
          }
        }

        // If booking question should be displayed in themake-it-yours
        // enhanced price breakdown component, rempve from company questions
        // and add to enhanced cost breakdown questions
        if (
          bookingQuestion.conditionals.hasOwnProperty(
            'fees-and-make-it-yours-enhancements'
          )
        ) {
          if (
            bookingQuestion.conditionals[
            'fees-and-make-it-yours-enhancements'
            ] === true ||
            bookingQuestion.conditionals[
            'fees-and-make-it-yours-enhancements'
            ] === 'true'
          ) {
            this.enhancedCostBreakdownQuestions = [
              ...this.enhancedCostBreakdownQuestions,
              this.mapToEnhancedCostBreakdownQuestion(bookingQuestion),
            ];
          }
        }

        // copy question schema
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('copy_data')) {
            bookingQuestion.copy_data_from =
              bookingQuestion.conditionals['copy_data'].from;
            bookingQuestion.copy_data_to =
              bookingQuestion.conditionals['copy_data'].to;
            bookingQuestion.copy_answer =
              bookingQuestion.conditionals['copy_data'].answer;

            if (
              bookingQuestion.answer == true ||
              bookingQuestion.copy_answer == bookingQuestion.answer
            ) {
              bookingQuestion.copy_data_from.forEach((fromId, index) => {
                const toId = bookingQuestion.copy_data_to[index];
                const sourceControl = this.companyQuestionsForm.get(
                  String(fromId)
                );
                const targetControl = this.companyQuestionsForm.get(
                  String(toId)
                );
                if (sourceControl && targetControl) {
                  targetControl.setValue(sourceControl.value);
                } else {
                  console.warn(
                    `Control not found for: ${fromId} or target: ${toId}`
                  );
                }
              });
            }
            // commented out because we cant clear the fields if there is no answer because
            // the field will be cleard everytime the user changes an answer but hasnt filled in the copy question
            // else {
            //   // clear all the copy_data_to fields
            //   bookingQuestion.copy_data_to.forEach((toId) => {
            //     const targetControl = this.companyQuestionsForm.get(String(toId));
            //     if (targetControl) {
            //       targetControl.setValue('');
            //     }
            //   });
            // }
          }
        }

        // add hidden field
        if (bookingQuestion.conditionals.hasOwnProperty('hidden_field')) {
          bookingQuestion.hidden = true;
        }

        // add duration schema
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('add_duration')) {
            this.dataStore.extraDuration =
              Number(this.dataStore.extraDuration) +
              Number(bookingQuestion.conditionals.add_duration);
          }
        }

        // set sevice question to var
        if (bookingQuestion.visible) {
          if (bookingQuestion.conditionals.hasOwnProperty('service_set')) {
            this.dataStore.setService =
              bookingQuestion.conditionals.service_set;
          }
        }

        // extra booking fee item
        if (bookingQuestion.visible) {
          await this.addExtraBookingItemFee(bookingQuestion);
        }

        // set client data on booking details page
        if (bookingQuestion.visible) {
          if (
            bookingQuestion.conditionals.hasOwnProperty('booker_first_name')
          ) {
            this.dataStore.booker_first_name = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_last_name')) {
            this.dataStore.booker_last_name = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_email')) {
            this.dataStore.booker_email = bookingQuestion.id;
          }
          if (bookingQuestion.conditionals.hasOwnProperty('booker_phone')) {
            this.dataStore.booker_phone = bookingQuestion.id;
          }
        }
        // if (bookingQuestion.conditionals.hasOwnProperty('continuebutton')) {
        //   // showContinueButton
        //   let conditionalQuestion = this.companyQuestionsForm.get(`${Object.keys(bookingQuestion.conditionals.continuebutton)[0]}`);
        //   console.log(conditionalQuestion);
        //   if (conditionalQuestion && conditionalQuestion.value != null) {
        //     if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
        //       if (Object.values(bookingQuestion.conditionals.continuebutton)[0][0] == "*") { // wildcard
        //         if ((conditionalQuestion.value || conditionalQuestion.value.length > 0)) {
        //           if (this.config["auto_select_service"]) {
        //             this.showContinueButton = true;
        //           } else {
        //             // filter services
        //             if (this.dataStore.setService) {
        //               this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.dataStore.setService}`);
        //             } else {
        //               this.filteredServiceList = this.servicesList;
        //             }
        //             // this.showServices = true;
        //           }
        //         }
        //       } else {
        //         if (conditionalQuestion.value == Object.values(bookingQuestion.conditionals.continuebutton)[0][0]) {
        //           if (this.config["auto_select_service"]) {
        //             this.showContinueButton = true;
        //           } else {
        //             // filter services
        //             if (this.dataStore.setService) {
        //               this.filteredServiceList = this.servicesList.filter(service => `${service.id}` == `${this.dataStore.setService}`);
        //             } else {
        //               this.filteredServiceList = this.servicesList;
        //             }
        //             // this.showServices = true;
        //           }
        //         }
        //       }
        //     }
        //   }
        // }

        // slice booking questions off for first-n
        if (bookingQuestion.visible && !bookingQuestion.optionsRemoved) {
          if (
            bookingQuestion.conditionals.hasOwnProperty(
              'remove-options-customer'
            )
          ) {
            let firstN =
              bookingQuestion.conditionals['remove-options-customer'][
              'first-n'
              ];
            if (!this.dataStore.adminJourney) {
              bookingQuestion.options = bookingQuestion.options.slice(firstN);
              bookingQuestion.optionsRemoved = true;
            }
          }
        }

        if (!this.dataStore.adminJourney && admin_only) {
          bookingQuestion.visible = false;
        }

        if (!bookingQuestion.visible) {
          let conditionalQuestion = this.companyQuestionsForm.get(
            `${bookingQuestion.id}`
          );
          conditionalQuestion.reset();
          conditionalQuestion.clearValidators();
          conditionalQuestion.updateValueAndValidity();
        }
      } else {
        bookingQuestion.visible = true;
      }
    }

    // remove cost enhancement questions from company questions
    // for (const question of this.enhancedCostBreakdownQuestions) {
    //   const index = this.companyQuestions.indexOf(question);

    //   if (index > -1) {
    //     this.companyQuestions.splice(index, 1);
    //   }
    // }
  }

  mapToEnhancedCostBreakdownQuestion(question: any) {
    question.detailType = question['detail_type'];

    if (question.conditionals['default']) {
      question.defaultValue = question.conditionals['default'];
    }

    return question;
  }

  async addExtraBookingItemFee(bookingQuestion: any) {
    // console.log('q', bookingQuestion);
    if (bookingQuestion.conditionals.hasOwnProperty('extra-item')) {
      bookingQuestion.extraItem = bookingQuestion.conditionals['extra-item'];
      bookingQuestion.extraItemLabel =
        bookingQuestion.conditionals['extra-item-label'];

      let cost;
      let costVar;

      if (bookingQuestion.answer && bookingQuestion.detail_type === 'select') {
        cost = bookingQuestion.options.filter(
          (option) => option.name == bookingQuestion.answer
        );
        costVar =
          cost[0].price > 0 ? cost[0].price / bookingQuestion.answer / 100 : 0;
      } else if (
        bookingQuestion.answer &&
        bookingQuestion.detail_type === 'number'
      ) {
        costVar = bookingQuestion.price / bookingQuestion.answer / 100;
      }

      const itemProps: any = await this.apiService.getExtraItemProperties(
        bookingQuestion.extraItem,
        this.dataStore.selectedDepartment.id,
        this.dataStore.selectedService.global_id
      );
      if (itemProps) {
        bookingQuestion.current_price = itemProps.item_price;
      }
      const serviceFee = this.dataStore.serviceFees.find(
				(item) => item.questionid === bookingQuestion.id
			);

			if (serviceFee) {
				bookingQuestion.answer = serviceFee.quantity;
			}
      this.costBreakDown.push({
        questionid: bookingQuestion.id,
        item: bookingQuestion.extraItemLabel,
        quantity: bookingQuestion.answer,
        cost: bookingQuestion.current_price || 0,
      });
      this.dataStore.triggerAddFees({
        questionid: bookingQuestion.id,
        item: bookingQuestion.extraItemLabel,
        quantity: bookingQuestion.answer,
        cost: bookingQuestion.current_price || 0,
      });
      await this.b2c.calculate();
    }
  }
}
